<script lang="ts">
    import Button from '../components/button.svelte';
    import { appState, windowWidth } from '../stores';
    import { fade, slide } from 'svelte/transition';

    function manageAppState(area:number) {
        $appState.view = area;
    }

    let transitionType = fade;
    $: if ($windowWidth <= 960) {
        transitionType = slide;
    } else {
        transitionType = fade;
    }

</script>

<div class="panel-parent">
    <section transition:transitionType={{duration: 150}}>
        <div class="close-button-area">
            <Button
                label=""
                icon="x"
                handleClick={() => manageAppState(0)}
                role="tertiary"
            />
        </div>
        <div class="content-area">
            <slot></slot> 
        </div>
    </section>
</div>

<style>
    .panel-parent {
        position:absolute;
        top: 0;
        display: flex;
        width: 100vw;
        height: 100vh;
        justify-content: center;
    }
    section {
        z-index: 10;
        position: absolute;
        top: 3vh;
        max-height: 86vh;
        max-width: 520px;
        background: var(--background);
        overflow-y: scroll;
        border-radius: 1rem;
        border: 1px solid var(--background-offset);
        padding: 2rem 6rem;
    }
    .close-button-area {
        position: absolute;
        right: 0;
        top: 0;
    }
    .content-area {
        height: 100%;
        overflow-y: scroll;
    }

    @media (max-width: 960px) {
        section {
            width: 100vw;
            max-width: unset;
            transform: translateX(0);
            max-height: 90vh;
            left: 0;
            bottom: 0;
            top: unset;
            padding: 0;
            border-radius: 1rem 1rem 0 0;
            border: 1px 0 0 0 solid var(--background-offset);
        }
    }
</style>